package com.klantenstop.web.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.materialkobweb.components.widgets.DsMaterialSymbols
import com.materialkobweb.components.widgets.MaterialSymbolType
import com.materialkobweb.styles.MaterialColorVars
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.onMouseEnter
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import org.jetbrains.compose.web.css.px

@Composable
fun KsStarRating(
    modifier: Modifier = Modifier,
    initialRating: Int = 0,
    onRatingSelected: (Int) -> Unit
) {
    val activeColor = MaterialColorVars.Primary.value()
    val inactiveColor = MaterialColorVars.PrimaryContainer.value()

    var hoveredRating by remember { mutableStateOf(0) }
    var selectedRating by remember { mutableStateOf(initialRating) }

    Row(
        modifier = modifier
            .onMouseLeave { hoveredRating = 0 }
    ) {
        repeat(5) { index ->
            val starValue = index + 1

            val isFilled = when {
                hoveredRating > 0 -> starValue <= hoveredRating
                else -> starValue <= selectedRating
            }

            DsMaterialSymbols(
                modifier = modifier
                    .onMouseEnter { hoveredRating = starValue }
                    .onClick {
                        selectedRating = starValue
                        onRatingSelected(starValue)
                    }
                    .cursor(Cursor.Pointer)
                    .margin(right = 4.px)
                    .fontSize(24.px),
                icon = if (isFilled) "star" else "star_border",
                type = MaterialSymbolType.Rounded,
                fill = true,
                color = if (isFilled) activeColor else inactiveColor
            )

        }
    }
}
